module.exports = __webpack_public_path__ + "static/media/synergy.dedbfae2.jpg";